var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as _ from "lodash";
import * as React from 'react';
import { styled } from '../theme/ThemeHelpers';
import { appendPx } from "../theme/DefaultTheme";
var ButtonGroupContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n    display: grid;\n    display: -ms-grid;\n    ", "\n    ", "\n    ", "\n"], ["\n    ", "\n    display: grid;\n    display: -ms-grid;\n    ", "\n    ",
    "\n    ",
    "\n"])), function (props) { return props.floated ? "" : "width: 100%;"; }, function (props) { return props.floated ? "float: " + props.floated + ";" : ""; }, function (props) {
    return props.spacing ?
        (props.vertical
            ? "grid-template-rows: " + _.times(props.buttons - 1, function (b) { return "1fr " + appendPx(props.spacing); }).join(" ") + " 1fr;"
            : "grid-template-columns: " + _.times(props.buttons - 1, function (b) { return "1fr " + appendPx(props.spacing); }).join(" ") + " 1fr;")
        : (props.vertical
            ? "grid-template-rows: repeat(" + props.buttons + ", 1fr);"
            : "grid-template-columns: repeat(" + props.buttons + ", 1fr);");
}, function (props) {
    return props.spacing ?
        (props.vertical
            ? "-ms-grid-rows: " + _.times(props.buttons - 1, function (b) { return "1fr " + appendPx(props.spacing); }).join(" ") + " 1fr;"
            : "-ms-grid-columns: " + _.times(props.buttons - 1, function (b) { return "1fr " + appendPx(props.spacing); }).join(" ") + " 1fr;")
        : (props.vertical
            ? "-ms-grid-rows: " + _.times(props.buttons, function (b) { return "1fr "; }) + ";"
            : "-ms-grid-columns: " + _.times(props.buttons, function (b) { return "1fr "; }) + ";");
});
var ButtonContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n    ", "\n"], ["\n    ",
    "\n    ",
    "\n"])), function (props) {
    return props.spacing ?
        (props.vertical
            ? "grid-row-start: " + (props.pos * 2 - 1) + ";"
            : "grid-column-start: " + (props.pos * 2 - 1) + ";")
        :
            (props.vertical
                ? "grid-row-start: " + props.pos + ";"
                : "grid-column-start: " + props.pos + ";");
}, function (props) {
    return props.spacing ?
        (props.vertical
            ? "-ms-grid-row: " + (props.pos * 2 - 1) + ";"
            : "-ms-grid-column: " + (props.pos * 2 - 1) + ";")
        :
            (props.vertical
                ? "-ms-grid-row: " + props.pos + ";"
                : "-ms-grid-column: " + props.pos + ";");
});
var ButtonGroup = React.memo(function (props) {
    var filtered = _.isArray(props.children) ? _.filter(props.children, function (c) {
        if (c)
            return true;
        return false;
    }) : undefined;
    var len = filtered ? filtered.length : 1;
    return (React.createElement("div", { style: { width: props.width ? props.width : (props.floated || props.fluid ? "100%" : "fit-content") } },
        React.createElement(ButtonGroupContainer, { buttons: len, vertical: props.vertical, spacing: props.spacing, floated: props.floated }, props.children && React.Children.map(filtered, function (c, i) { return (React.createElement(ButtonContainer, { pos: i + 1, key: i, vertical: props.vertical, spacing: props.spacing }, React.cloneElement(c, { fluid: props.fluid ? props.fluid : true }))); }))));
});
export default ButtonGroup;
var templateObject_1, templateObject_2;
//# sourceMappingURL=ButtonGroup.js.map